import stylesheet from './style.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class NXTButtonGroup extends CustomComponent {
    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    get variant() {
        return this.getAttribute('variant') ?? 'horizontal';
    }

    getGroupBreakpointVariants(): string[] {
        const additionalClasses: string[] = [];
        for (const breakpoint of ['md', 'lg', 'xl', 'xxl']) {
            const attributeName = `variant-${breakpoint}`;
            if (this.hasAttribute(attributeName)) {
                additionalClasses.push(`variant-${this.getAttribute(attributeName)}-${breakpoint}-up`);
            }
        }
        return additionalClasses;
    }

    get align() {
        return this.getAttribute('align') ?? 'start';
    }

    render() {
        const container = document.createElement('div');
        container.classList.add(
            `button-group`,
            `variant-${this.variant}`,
            ...this.getGroupBreakpointVariants(),
            `align-${this.align}`
        );
        container.innerHTML = `<slot></slot>`;
        return container;
    }

}

customElements.define('nxt-button-group', NXTButtonGroup);
